import React from "react";
import { Shapes, ChartLine, Lightbulb } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Conceptual Understanding",
  description: "Moving beyond rote memorization to ensure students grasp the 'why' behind every property and procedure. We work collaboratively to strengthen understanding of mathematical principles.",
  icon: Shapes
}, {
  title: "Procedural Fluency",
  description: "Developing efficiency and accuracy required for problem solving. Through student-centered learning strategies and structured practice,\xA0 students master the steps needed to solve complex problems with ease.",
  icon: ChartLine
}, {
  title: "Confidence Building",
  description: "Transforming math anxiety into academic empowerment. By learning from mistakes, mastering difficult topics, and achieving academic goals, students develop a growth mindset that lasts a lifetime.",
  icon: Lightbulb
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="my-teaching-philosophy" className="w-full bg-background py-20 md:py-28 text-foreground light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-3xl bg-secondary/10 px-6 py-16 md:px-12 md:py-20 lg:px-16 backdrop-blur-sm">
          <div className="mx-auto mb-16 max-w-2xl text-center">
            <h2 className="font-default text-3xl font-semibold tracking-tight text-foreground md:text-4xl">
              My Teaching Philosophy
            </h2>
            <p className="mt-4 text-lg text-muted-foreground font-default">
              A sophisticated, research-backed approach to mastering mathematics through three core pillars of excellence.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className="group border-2 border-transparent bg-card shadow-lg transition-colors duration-300 hover:border-primary hover:shadow-3xl rounded-lg">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10 text-primary transition-transform duration-300 ease-out group-hover:-translate-y-2">
                      <Icon className="h-8 w-8 stroke-[1.5]" />
                    </div>
                    <CardTitle className="font-default text-2xl text-foreground">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-muted-foreground font-default">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}